import http from '@/plugins/axios';
import i18n from '@/i18n/index';

export default {
  rulesWhenToOfferSearchProducts(search) {
    const params = {
      search,
    };
    return http
      .get('/coupon-products', {
        params,
      })
      .then(res => {
        return res.data.data.map(product => {
          product.isVisible = true;
          product.disabled = product.isInCoupon ? true : false;
          product.text = product.disabled
            ? `${product.text}  (${i18n.t('Coupons.usedInCoupon', [product.isInCoupon])})`
            : `${product.text}`;

          return product;
        });
      });
  },
  rulesCustomerSearchProducts(search) {
    const params = {
      search,
    };
    return http
      .get('/products', {
        params,
      })
      .then(res => {
        return res.data.data.map(product => {
          product.isVisible = true;
          return product;
        });
      });
  },
  addCoupon({
    target_type,
    value_type,
    value,
    minimum_purchase_value,
    price_rule_entitled_product_ids,
    price_rule_excluded_product_ids,
    review_type,
    photo_request,
    expire_after_days,
  }) {
    const data = {
      target_type,
      value_type,
      value,
      minimum_purchase_value,
      price_rule_entitled_product_ids,
      price_rule_excluded_product_ids,
      review_type,
      photo_request,
      expire_after_days,
    };

    return http.post('/coupon-rules/create', data);
  },
  deleteCoupon(id) {
    return http.post(`/coupons/${id}/delete`);
  },
  getCoupons({ rowsPerPage, sortBy, descending, page }) {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      orderDirection: descending ? 'desc' : 'asc',
    };
    return http
      .get('/coupons', {
        params,
      })
      .then(res => res.data);
  },
  checkCouponNameUnique({ couponType, couponName }) {
    const params = {
      coupon_type: couponType,
      code: couponName,
    };
    return http
      .get('/coupons/check-if-already-exists', {
        params,
      })
      .then(res => res.data);
  },
};
